<template>
    <h5 class="mt-4">Folders</h5>
    <ul class="folder">
        <li class="folder-box">
            <div class="d-block"><i class="f-44 fa fa-file-archive-o txt-warning"></i><i
                    class="fa fa-ellipsis-v me-0 f-14 ellips"></i>
                <div class="mt-3">
                    <h6>Endless admin</h6>
                    <p>20 files<span class="pull-right"> <i class="fa fa-clock-o"> </i> 2 Hour ago</span>
                    </p>
                </div>
            </div>
        </li>
        <li class="folder-box">
            <div class="d-block"><i class="f-44 fa fa-folder txt-warning"></i><i
                    class="fa fa-ellipsis-v me-0 f-14 ellips"></i>
                <div class="mt-3">
                    <h6>Universal admin</h6>
                    <p>14 files<span class="pull-right"> <i class="fa fa-clock-o"> </i> 3 Hour ago</span>
                    </p>
                </div>
            </div>
        </li>
        <li class="folder-box">
            <div class="d-block"><i class="f-44 fa fa-file-archive-o txt-warning"></i><i
                    class="fa fa-ellipsis-v me-0 f-14 ellips"></i>
                <div class="mt-3">
                    <h6>Unice admin</h6>
                    <p>15 files<span class="pull-right"> <i class="fa fa-clock-o"> </i> 3 Day ago</span></p>
                </div>
            </div>
        </li>
        <li class="folder-box">
            <div class="d-block"><i class="f-44 fa fa-folder txt-warning"></i><i
                    class="fa fa-ellipsis-v me-0 f-14 ellips"></i>
                <div class="mt-3">
                    <h6>Koho admin</h6>
                    <p>10 files<span class="pull-right"> <i class="fa fa-clock-o"> </i> 1 Day ago</span></p>
                </div>
            </div>
        </li>
    </ul>
    <h5 class="mt-4">Files </h5>
    <ul class="flex-row files-content">
        <li class="folder-box d-flex align-items-center">
            <div class="d-flex align-items-center files-list">
                <div class="flex-shrink-0 file-left"><i class="f-22 fa fa-folder font-info"></i></div>
                <div class="flex-grow-1 ms-xxl-3 ms-xl-2">
                    <h6>Logo.psd</h6>
                    <p>2 Hour ago, 2.0 MB</p>
                </div>
            </div>
        </li>
        <li class="folder-box d-flex align-items-center">
            <div class="d-flex align-items-center files-list">
                <div class="flex-shrink-0 file-left"><i class="f-22 fa fa-file-excel-o font-success"></i>
                </div>
                <div class="flex-grow-1 ms-xxl-3 ms-xl-2">
                    <h6>Backend.xls</h6>
                    <p>2 Day ago, 3.00 GB</p>
                </div>
            </div>
        </li>
        <li class="folder-box d-flex align-items-center">
            <div class="d-flex align-items-center files-list">
                <div class="flex-shrink-0 file-left"><i class="f-22 fa fa-file-archive-o font-warning"></i>
                </div>
                <div class="flex-grow-1 ms-xxl-3 ms-xl-2">
                    <h6>Project.zip</h6>
                    <p>3 Hour ago, 1.90 GB</p>
                </div>
            </div>
        </li>
        <li class="folder-box d-flex align-items-center">
            <div class="d-flex align-items-center files-list">
                <div class="flex-shrink-0 file-left"><i class="f-22 fa fa-folder font-info"></i></div>
                <div class="flex-grow-1 ms-xxl-3 ms-xl-2">
                    <h6>Requirements.txt</h6>
                    <p>1 Day ago, 0.90 KB</p>
                </div>
            </div>
        </li>
    </ul>
</template>